import OfferActiveStateGuard from '@components/display/OfferActiveStateGuard'
import Layout from '@components/layout/Main'
import TwoColumns from '@components/layout/TwoColumns'
import DisplaySection from '@components/display/DisplaySection'
import Breadcrumbs from '@components/breadcrumbs/Breadcrumbs'
import TitlePrice from '@components/display/TitlePrice'
import ActivePhotoContext from '@context/ActivePhotoContext'
import Triptic from '@components/display/Triptic'
import Photo from '@components/display/photos/MainPhoto'
import Thumbnails from '@components/display/photos/Thumbnails'
import UserDetails from '@components/display/user/Details'
import UserLocation from '@components/display/user/Location'
import Flag from '@components/display/flag/DynamicFlag'
import Seo from 'src/seo/components/Seo'
import JsonLdDisplay from 'src/seo/jsonld/JsonLdDisplay'

import { ACCESSORY_LINK_BASE } from '@constants/searchFormLinks'
import ShortSpecifications from '@components/display/offer/ShortSpecificationsAltPart'
import Specifications from '@components/display/offer/Specifications'
import Equipment from '@components/display/offer/Equipment'

import Description from '@components/display/offer/Description'
import Similar from '@components/display/offer/Similar'
import FrontpageLinks from '@components/frontpage/FrontpageLinks'
import withOfferIncreaseView from '@hoc/withOfferIncreaseView'

import dbConnect from 'db/dbConnect'
import { getAccessory } from 'db/repo/ad'
import listAdsAccessory from 'db/repo/listAds/listAdsAccessory'
import usePageSeoWithOfferParams from 'src/seo/server/usePageSeoWithOfferParams'
// import makeDisplayPartLinks from '@components/frontpage/functions/makeDisplayPartLinks'

function DisplayAccessory ({ cubeLinks, offer, similar, seo }) {
    const user = offer?._user
    const isDeleted = offer?.tracking?.deleted

    return (
        <Layout>
            <Seo seo={seo} />
            <JsonLdDisplay buy={false} offer={offer} />
            <div style={{ background: 'var(--background-grey)'}}>
                <OfferActiveStateGuard offer={offer} />
                <DisplaySection gray>
                    <br/><Breadcrumbs /><br/>
                    <TitlePrice offer={offer} />
                </DisplaySection>

                <DisplaySection borders white>
                    <ActivePhotoContext offer={offer}>
                        <Triptic>
                            <Photo offer={offer} />
                            <UserDetails displayOn="desktop" offer={offer} user={user} />
                            <UserLocation user={user} offer={offer} />
                        </Triptic>
                        <Thumbnails offer={offer} />
                    </ActivePhotoContext>
                    <Flag offer={offer} />
                </DisplaySection>

                {
                    !isDeleted && <>
                        <div className="container">
                            <ShortSpecifications offer={offer} />
                        </div>

                        <DisplaySection gray>
                            <TwoColumns>
                                <Specifications offer={offer} linkBase={ACCESSORY_LINK_BASE} />
                                <Equipment offer={offer} />
                            </TwoColumns>
                        </DisplaySection>

                        <DisplaySection white>
                            <Description offer={offer} />
                            <UserDetails displayOn="mobile" offer={offer} user={user} />
                        </DisplaySection>
                    </>
                }

                <DisplaySection white>
                    <Similar linkBase={ACCESSORY_LINK_BASE} offer={offer} offers={similar} />
                </DisplaySection>
            </div>

            <FrontpageLinks sections={cubeLinks} />
        </Layout>
    )
}

export async function getServerSideProps (context) {
    await dbConnect()
    const query = context.query
    const offer = await getAccessory(query)

    if (offer == null) {
        return {
            redirect: {
                permanent: false,
                destination: '/akcesoria-samochody-dostawcze',
            }}
    }

    const { ads: similar } = await listAdsAccessory({}, {
            match: {
                _shortid: { $ne: offer?._shortid },
                title: offer?.title,
            },
            limit: 2,
            pagination: false,
        })

    return {
        props: {
            cubeLinks: [], // await makeDisplayPartLinks(query, '/akcesoria-samochody-dostawcze'),
            offer,
            similar,
            seo: await usePageSeoWithOfferParams({
                pageId: 'oferta-akcesoria',
                query,
                offer,
            }),
        }
    }
}

export default withOfferIncreaseView(DisplayAccessory)